// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"152":"1eff5260","678":"5e550f78"}[chunkId] + ".js";
};